export const prepareSelectValue = (value, label = null) => {
  if (value && label) {
    return { value, label };
  }
  if (!label) {
    return { value, label: value };
  }
  return '';
};
